import { Box } from '@mui/material';
import * as R from 'ramda';
import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { AppFooter, AppHeader, AppSidebar } from '@/containers';
import { selectActiveChapterId, selectIsNavBannerVisible } from '@/store';

interface AppLayoutProps {
  children: React.ReactNode;
  showFooter?: boolean;
  showHeader?: boolean;
}

export const AppLayout = ({
  children,
  showFooter = true,
  showHeader = true,
}: AppLayoutProps) => {
  const hasNavBanner = useSelector(selectIsNavBannerVisible);
  const activeChapterId = useSelector(selectActiveChapterId);

  const { pathname } = useLocation();
  const containerRef = useRef<HTMLElement>(null);

  useEffect(() => {
    containerRef.current?.scrollIntoView();
  }, [pathname]);

  return (
    <Box
      ref={containerRef}
      sx={({ dimensions }) => ({
        minHeight: '100vh',
        width: '100%',
        pt: `${(showHeader ? dimensions.header.height : 0) + (hasNavBanner ? dimensions.navBanner.height : 0)}px`,
        pl: 0,
        pb: ({ dimensions }) =>
          activeChapterId
            ? R.map(px => `${px}px`, dimensions.miniPlayer.height)
            : 0,
      })}>
      {showHeader && <AppHeader />}
      <AppSidebar />
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          overflow: 'hidden',
          px: ({ dimensions }) => dimensions.appLayout.px,
          py: ({ dimensions }) => dimensions.appLayout.py,
        }}
        component="main">
        {children}
      </Box>
      {showFooter && <AppFooter />}
    </Box>
  );
};
